import { z } from "zod";
import "../zod-runtime.js";
export const mediaVariantSchema = z.object({
    hash: z.string().regex(/^[a-f0-9]{64}$/),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    path: z.string().min(1),
    mimeType: z.literal("image/webp"),
});
/** Koordinaten sind Anteile (0..1) des fertig zugeschnittenen Bildes — derselbe Raum wie `crop`s Ergebnis. */
export const guideLineSchema = z.object({
    id: z.string().uuid(),
    x1: z.number().min(0).max(1),
    y1: z.number().min(0).max(1),
    x2: z.number().min(0).max(1),
    y2: z.number().min(0).max(1),
});
export const mediaAssetSchema = z.object({
    id: z.string().uuid(),
    originalName: z.string().min(1),
    mimeType: z.enum(["image/jpeg", "image/png", "image/webp"]),
    width: z.number().int().positive().max(4096),
    height: z.number().int().positive().max(4096),
    sizeBytes: z
        .number()
        .int()
        .positive()
        .max(10 * 1024 * 1024),
    masterPath: z.string().min(1),
    crop: z.object({
        x: z.number().min(0).max(1),
        y: z.number().min(0).max(1),
        width: z.number().positive().max(1),
        height: z.number().positive().max(1),
        zoom: z.number().min(1).max(8),
        rotation: z.union([
            z.literal(0),
            z.literal(90),
            z.literal(180),
            z.literal(270),
        ]),
    }),
    variants: z.array(mediaVariantSchema).length(2),
    guides: z.array(guideLineSchema).max(6).default([]),
});
